module.exports = __webpack_public_path__ + "img/testimonial-light.2e10cd20.png";